





































import Vue from 'vue'
import CaseChooser from '@/components/layout/CaseChooser.vue'

import { types, params } from '@/components/registration/module/types'

export default Vue.extend({
  components: { CaseChooser },
  computed: {
    isSignedIn(): boolean {
      return this.$store.getters.isSignedIn
    },
    isInterviewer(): boolean {
      return this.$store.getters.currentUser!.is_interviewer_account
    },
    isPatient(): boolean {
      return this.$store.getters.currentUser!.is_patient_account
    },
    numberOfCases(): number {
      return this.$store.getters.numberOfCases
    },
  },
  data: () => ({
    showSignInModal: false,
    signInForm: {
      login: '',
      password: '',
    },
  }),
  methods: {
    logout() {
      this.$store.dispatch({ type: 'logout' })
    },
    resetSignInForm() {
      this.signInForm = {
        login: '',
        password: '',
      }
    },
    signIn() {
      this.$store
        .dispatch({
          credentials: this.signInForm,
          type: types.actions.Login,
        })
        .then(() => {
          this.showSignInModal = false
        })
    },
  },
})
